<template>
  <el-select clearable :value="value" @input="updateValue" placeholder="请选择厂商" @clear="updateValue(undefined)">
    <el-option
      v-for="item in list"
      :key="item.id"
      :label="item.name"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
export default {
  data () {
    return {
      list: [
        { id: 'guest', name: '来宾管理员' },
        { id: 'admin', name: '普通管理员' },
        { id: 'super', name: '超级管理员' }
      ]
    }
  },
  created: function () {
  },
  methods: {
    updateValue (val) {
      this.$emit('input', val)
    }
  },
  props: {
    value: { required: true }
  }
}
</script>



// WEBPACK FOOTER //
// UserTypeSelect.vue?49fe6390